import React, { FC, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { get_asignaturas_tp } from "../services/api";
import SpinnerUmmIA from "../components/Loading/SpinnerUmmIA";

export interface FormattedAsignaturaTP {
  id: string;
  nombre: string;
}

interface Props {
  especialidadId: string;
  nivelId: string;
  selectedAsignaturaId: string; 
  onAsignaturaChange: (asignatura: FormattedAsignaturaTP) => void; // expone id + nombre
  disabled?: boolean;
  label?: string;
}

const GetAsignaturasTP: FC<Props> = ({
  especialidadId,
  nivelId,
  selectedAsignaturaId,
  onAsignaturaChange,
  disabled = false,
  label = "Asignatura TP *",
}) => {
  const [data, setData] = useState<FormattedAsignaturaTP[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAsignaturasTP = async () => {
      
      if (!especialidadId || !nivelId) {
        setData([]);
        return;
      }

      setLoading(true);
      try {
        const resp = await get_asignaturas_tp(especialidadId, nivelId);

        if (!resp || resp.status !== 200) {
          console.error("get_asignaturas_tp: respuesta inválida", resp);
          setData([]);
          return;
        }

        
        const raw = Array.isArray(resp.data?.data) ? resp.data.data : [];

       
        const asignaturas: FormattedAsignaturaTP[] = raw
          .map((a: any) => ({
            id: String(a.id_asignatura ?? a.id ?? a.asignaturaId ?? ""),
            nombre: String(a.name ?? a.nombre ?? ""),
          }))
          .filter((a: any) => a.id && a.nombre);

        setData(asignaturas);
      } catch (error) {
        console.error("Error consultando asignaturas TP:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAsignaturasTP();
  }, [especialidadId, nivelId]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    const seleccion = data.find((x) => x.id === selectedId);
    if (seleccion) onAsignaturaChange(seleccion);
  };


  return (
    <Grid item xs={12}>
      <Box>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          {label}
        </Typography>

        <FormControl fullWidth>
          <Select
            labelId="select-asignatura-tp"
            id="select-asignatura-tp"
            variant="outlined"
            value={selectedAsignaturaId || ""}
            displayEmpty
            onChange={handleChange}
            //disabled={isDisabled}
            renderValue={(value) => {
              if (!especialidadId) return "Selecciona primero una especialidad";
              if (!nivelId) return "Selecciona primero un nivel";
              if (!value) return "Selecciona por ejemplo: Asignatura";
              const found = data.find((x) => x.id === value);
              return found?.nombre ?? "Asignatura";
            }}
            sx={{
              fontFamily: "montserrat",
              fontSize: "14px",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": { borderRadius: 2 },
              "& fieldset": { borderColor: "#BDBDBD" },
              "&:hover fieldset": { borderColor: "#9E9E9E" },
              "&.Mui-focused fieldset": { borderColor: "#005559" },
              "& .MuiSelect-select": {
                color: selectedAsignaturaId ? "#005559" : "#B3D1D1",
              },
            }}
          >
         

            {loading && (
              <MenuItem value="" disabled>
                <Box display="flex" alignItems="center" gap={1}>
                  <SpinnerUmmIA logoWidth={20} logoHeight = {20}/>
                  Cargando...
                </Box>
              </MenuItem>
            )}

            {data.map((asig) => (
              <MenuItem key={asig.id} value={asig.id} sx={{ color: "#005559" }}>
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  {asig.nombre}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
};

export default GetAsignaturasTP;
